module.exports = __webpack_public_path__ + "static/media/Cedar Psychiatry Square.61fe51e8.png";